import { render } from "./SectionSpacerBar.vue?vue&type=template&id=999d4246&ts=true"
import script from "./SectionSpacerBar.vue?vue&type=script&lang=ts"
export * from "./SectionSpacerBar.vue?vue&type=script&lang=ts"

import "./SectionSpacerBar.vue?vue&type=style&index=0&id=999d4246&lang=scss"

import exportComponent from "C:\\Arbeit\\wordpress_projekte\\castroper-klimahelden\\wp-content\\themes\\cas-klimahelden-theme\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__